import { ActionTree } from 'vuex';
import { patchDashboardSetting, syncDashboardSetting } from '@/features/dashboard/services/dashboard.services';
import Dashboard, { WidgetSettings } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: ActionTree<Dashboard, any> = {
  async syncDashboardSetting({ commit }, payload: WidgetSettings): Promise<void> {
    commit('updateWidgetSettings', { ...payload });

    syncDashboardSetting({
      dashboardWidget: payload.dashboardWidget.charAt(0).toUpperCase()
        + payload.dashboardWidget.slice(1),
      itemsShown: payload.itemsShown,
      customSettings: payload.customSettings,
    });
  },

  async syncWidgetShow(
    { state, commit, dispatch }, { key, value }: { key: string, value: boolean },
  ): Promise<void> {
    commit('setWidgetShow', { key, value });

    const currentWidget = state.widgets[key];
    dispatch('patchDashboardSetting', { size: currentWidget.size });
  },

  async patchDashboardSetting({ state }, { size, updatePositions = true }: { size: 'big' | 'small', updatePositions?: boolean }) {
    const widgetElements = Object.entries(state.widgets).map((el) => {
      return {
        ...el[1],
        key: el[0],
      };
    });

    const widgets = widgetElements.filter(
      (widget) => widget.show === true && widget.size === size,
    ).sort((a, b) => {
      return a.position - b.position;
    });

    let order: string[] = [];

    if (widgets && widgets.length && updatePositions) {
      let position = 1;
      widgets.forEach((widget) => {
        state.widgets[widget.key].position = position;
        position += 1;
      });
    }

    if (widgets && widgets.length) {
      order = widgets.map((w) => w.key.charAt(0).toUpperCase() + w.key.slice(1));
    }

    patchDashboardSetting([
      {
        path: `order/${size}`,
        op: 'replace',
        value: order,
      },
    ]);
  },
};

export default actions;
